import React from "react";
import NavTop from "./nav_top.tsx";
export default function NavMain({
    toggleMenu,
    domain,
    handleChange
}) {
    return <NavTop toggleMenu={toggleMenu} domain={domain} handleChange={handleChange} />;
}
